var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.platforms),function(platform){return _c('platform-logo',{key:platform,attrs:{"platform":platform}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }